module.exports = __webpack_public_path__ + "static/media/ci-logo.d2fef433.png";